
export type SideT = "left"|"right"

export interface TugState {
    viewType: string|null;
    userPosition: string|null
    measuring?: boolean;
    duration?: number|null;
    result?: number|null;
    state?: string|null;
    popupMessage?: string|null;
}


export function initialTugState() : TugState {
    return {
        viewType: null,
        userPosition: null
    }
}